import { useQueryClient } from "@tanstack/react-query";
import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";

type UpdatePaidServiceParams = {
  studentId: string;
  paidServiceId: number;
  sectionId: string;
};

export const useEnablePaidService = () => {
  const queryClient = useQueryClient();

  return useBoronMutation(
    async ({ studentId, paidServiceId }: UpdatePaidServiceParams) => {
      return await boronClient.POST(
        "/api/v1/students/{student_id}/paid_services/{paid_service_id}",
        {
          params: {
            path: {
              student_id: studentId,
              paid_service_id: paidServiceId,
            },
          },
        },
      );
    },
    {
      onSuccess: (_, { sectionId, studentId }) => {
        queryClient.invalidateQueries({
          queryKey: [
            `/api/v1/sections/${sectionId}/students/${studentId}/paid_service_availabilities`,
          ],
        });
        queryClient.invalidateQueries({
          queryKey: ["students", sectionId],
        });
      },
    },
  );
};

export const useDisablePaidService = () => {
  const queryClient = useQueryClient();

  return useBoronMutation(
    async ({ studentId, paidServiceId }: UpdatePaidServiceParams) => {
      return await boronClient.DELETE(
        "/api/v1/students/{student_id}/paid_services/{paid_service_id}",
        {
          params: {
            path: {
              student_id: studentId,
              paid_service_id: paidServiceId,
            },
          },
        },
      );
    },
    {
      onSuccess: (_, { sectionId, studentId }) => {
        queryClient.invalidateQueries({
          queryKey: [
            `/api/v1/sections/${sectionId}/students/${studentId}/paid_service_availabilities`,
          ],
        });
        queryClient.invalidateQueries({
          queryKey: ["students", sectionId],
        });
      },
    },
  );
};
